import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import { Text } from '@/components/atoms/Text';

export type BentoInfocardBadgeProps = {
  text: string;
  icon?: ImageStrapiProps;
};

export function BentoInfocardBadge({ text, icon }: BentoInfocardBadgeProps) {
  return (
    <span className='inline-flex items-center justify-center gap-1 rounded-sm border !border-gray-dark-600 !bg-gray-dark-800 px-3 py-1'>
      {icon && (
        <ImageStrapi
          block={icon}
          width={6}
          height={6}
          inner={{
            classNames: {
              container: 'size-1.5 min-w-0 shrink-0',
              image: 'size-1.5',
            },
          }}
        />
      )}
      <Text
        as='span'
        variant='label-s'
        color='gray-dark-400'
        classNames={{
          wrapper: 'whitespace-nowrap uppercase tracking-wide font-serif',
        }}
      >
        {text}
      </Text>
    </span>
  );
}
